/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', () => {
    const jobTitles = document.querySelectorAll('.job-post > h3:not(.empty)');

    jobTitles.forEach(title => {
        title.addEventListener('click', () => {
            // Toggle the open class on the title
            title.classList.toggle('open');
            
            // Get the content container
            const content = title.parentElement.querySelector('.job-content');

            // Toggle display between none and block
            if (content.style.display === 'none' || !content.style.display) {
                content.style.display = 'block';
                anime({
                    targets: content,
                    height: [0, content.scrollHeight],
                    opacity: [0, 1],
                    duration: 300,
                    easing: 'easeOutCubic'
                });
            } else {
                anime({
                    targets: content,
                    height: [content.scrollHeight, 0], 
                    opacity: [1, 0],
                    duration: 300,
                    easing: 'easeOutCubic',
                    complete: () => {
                        content.style.display = 'none';
                    }
                });
            }
        });
    });
});
